class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this.opener = document.querySelector(`[data-modal-opener="${this.id}"]`);
    this.closeButton = this.querySelector('[data-modal-close]');
    this.overlay = this.querySelector('.size-guide-drawer__overlay');
    this.drawer = this;
    this.handleKeyDown = null;
    this.bindEvents();
  }

  bindEvents() {
    this.opener.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });
  }

  open() {
    this.drawer.setAttribute('open', '');
    this.opener.setAttribute('aria-expanded', 'true');
    this.handleKeyDown = this.trapFocus(this.drawer);
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.drawer.classList.add('closing');
    this.drawer.removeAttribute('open');
    this.opener.setAttribute('aria-expanded', 'false');
    this.removeTrapFocus(this.opener);
    document.body.classList.remove('overflow-hidden');

    this.drawer.addEventListener('transitionend', () => {
      this.drawer.classList.remove('closing');
    }, { once: true });
  }

  trapFocus(element) {
    const focusableElements = element.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (!firstFocusableElement) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    };

    element.addEventListener('keydown', handleKeyDown);
    firstFocusableElement.focus();

    return handleKeyDown;
  }

  removeTrapFocus(elementToFocus) {
    if (this.handleKeyDown) {
      this.drawer.removeEventListener('keydown', this.handleKeyDown);
      this.handleKeyDown = null;
    }
    elementToFocus?.focus();
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);
